import React from 'react';
import { InsumosTabs } from '../components/InsumosTabs';
import ListarInsumos from '../components/insumos/insumos/ListarInsumos';
import ListarObjetos from '../components/insumos/objetos/ListarObjetos';
import { theme } from '../theme';

const InsumosPage: React.FC = () => {
  return (
    <div style={{ padding: '0' }}>
      {/* Título de la página */}
      <div style={{ marginBottom: '24px' }}>
        <h1 style={{ 
          fontSize: theme.fontSizes.xxlarge,
          fontWeight: 600,
          color: theme.colors.primaryDark,
          margin: 0
        }}>
          Gestión de Insumos
        </h1>
        <p style={{
          color: theme.colors.textSecondary,
          marginTop: '8px',
          fontSize: theme.fontSizes.normal
        }}>
          Administración de insumos y objetos del depósito
        </p>
      </div>

      {/* Tabs con los componentes existentes */}
      <InsumosTabs
        insumosComponent={<ListarInsumos />}
        objetosComponent={<ListarObjetos />}
      />
    </div>
  );
};

export default InsumosPage;

